import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { wagmiConfig } from './service/web3/wagmi';

// telegramAnalytics.init({
//     token: process.env.REACT_APP_TG_ANALYTICS_TOKEN,
//     appName: 'chw_mini_staging',
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
root.render(
    <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </WagmiProvider>
);

